import { setMetadataMap } from 'eurogard-reflect-metadata';
import { RxapAbstractControlOptions } from '../model';
import { MetadataKeys } from './metadata-keys';

export function UseFormControl(options: RxapAbstractControlOptions = {}) {

  return function (target: any, propertyKey: string) {

    setMetadataMap(propertyKey, options, MetadataKeys.FORM_CONTROLS, target);

  };

}

